/**
 * Lấy ra tên cache theo tên cột trên giao diện
 * NHANH3 08.05.2023
 */
export default {
  // Tài khoản Nợ
  debit_account: {
    storeName: 'accountCombo',
    queryMode: 'local',
    checkField: 'account_number',
    valueField: 'debit_account',
    caption: 'Tài khoản Nợ',
  },
  // Tài khoản Có
  credit_account: {
    storeName: 'accountCombo',
    queryMode: 'local',
    checkField: 'account_number',
    valueField: 'credit_account',
    caption: 'Tài khoản Có',
  },
  // Hoạt động
  activity_name: {
    storeName: 'activity',
    queryMode: 'local',
    checkField: 'activity_id',
    valueField: 'activity_id',
    caption: 'Hoạt động'
  },
  // Chương
  budget_chapter_code: {
    storeName:  'budgetChapter',
    queryMode: 'local',
    checkField: 'budget_chapter_code',
    valueField: 'budget_chapter_code',
    caption: 'Chương'
  },
  budget_chapter_id: {
    storeName:  'budgetChapter',
    queryMode: 'local',
    checkField: 'budget_chapter_id',
    valueField: 'budget_chapter_id',
    caption: 'Chương'
  },
  // Mục
  budget_item_id: {
    storeName: 'budgetItem', 
    queryMode: 'local',
    checkField: 'budget_item_id',
    valueField: 'budget_item_id',
    caption: 'Mục'
  },
  budget_item_code: {
    storeName: 'budgetItem', 
    queryMode: 'local',
    checkField: 'budget_item_code',
    valueField: 'budget_item_code',
    caption: 'Mục'
  },
  // Tiểu mục
  budget_sub_item_code: {
    storeName: 'budgetItem',
    queryMode: 'local',
    checkField: 'budget_item_code',
    valueField: 'budget_sub_item_code',
    caption: 'Tiểu mục'
  },
  // Loại
  budget_kind_item_id: {
    storeName:  'budgetKindItem', 
    queryMode: 'local',
    checkField: 'budget_kind_item_id',
    valueField: 'budget_kind_item_id',
    caption: 'Loại'
  },
  budget_kind_item_code: {
    storeName:  'budgetKindItem', 
    queryMode: 'local',
    checkField: 'budget_kind_item_code',
    valueField: 'budget_kind_item_code',
    caption: 'Loại'
  },
  // Khoản
  budget_sub_kind_item_code: {
    storeName:  'budgetKindItem', 
    queryMode: 'local',
    checkField: 'budget_kind_item_code',
    valueField: 'budget_sub_kind_item_code',
    caption: 'Khoản'
  },
  // Mã dự phòng
  budget_provide_code: {
    storeName: 'budgetProvide', 
    queryMode: 'local',
    checkField: 'budget_provide_code',
    valueField: 'budget_provide_code',
    caption: 'Mã dự phòng'
  },
  // Nguồn
  budget_source_id: {
    storeName:  'budgetSource',
    queryMode: 'local',
    checkField: 'budget_source_id',
    valueField: 'budget_source_id',
    caption: 'Nguồn'
  },
  budget_source_name: {
    storeName:  'budgetSource',
    queryMode: 'local',
    checkField: 'budget_source_id',
    valueField: 'budget_source_id',
    caption: 'Nguồn'
  },
  // Mã thống kê
  statistic_code: {
    storeName: 'statistic',
    queryMode: 'local',
    checkField: 'statistic_code',
    valueField: 'statistic_code',
    caption: 'Mã thống kê'
  },
  // Loại quỹ
  fund_code: {
    storeName: 'typeOfFund',
    queryMode: 'local',
    checkField: 'fund_id',
    valueField: 'fund_id',
    caption: 'Loại quỹ'
  },
  // Cơ cấu vốn
  fund_structure_name: {
    storeName: 'fundStructure',
    queryMode: 'local',
    checkField: 'fund_structure_id',
    valueField: 'fund_structure_id',
    caption: 'Cơ cấu vốn'
  },
  // Nhiệm vụ
  task_code: {
    storeName: 'task',
    queryMode: 'local',
    checkField: 'task_id',
    valueField: 'task_id',
    caption: 'Nhiệm vụ'
  },
  // Phí, lệ phí
  budget_fees_id: {
    storeName: 'budgetFees',
    queryMode: 'local',
    checkField: 'budget_fees_id',
    valueField: 'budget_fees_id',
    caption: 'Phí, lệ phí'
  },
  budget_fees_code: {
    storeName: 'budgetFees',
    queryMode: 'local',
    checkField: 'budget_fees_id',
    valueField: 'budget_fees_id',
    caption: 'Phí, lệ phí'
  },
  // Hợp đồng
  contract_no: {
    storeName: 'contract',
    queryMode: 'local',
    checkField: 'contract_id',
    valueField: 'contract_id',
    caption: 'Hợp đồng'
  },
  // Nhóm hàng, hóa dịch vụ mua vào
  purchase_purpose_id: {
    storeName: 'purchasePurpose',
    queryMode: 'local',
    checkField: 'purchase_purpose_id',
    valueField: 'purchase_purpose_id',
    caption: 'Nhóm HHDV'
  },
  purchase_purpose_code: {
    storeName: 'purchasePurpose',
    queryMode: 'local',
    checkField: 'purchase_purpose_code',
    valueField: 'purchase_purpose_code',
    caption: 'Nhóm HHDV'
  },
  // Nhóm mục chi
  budget_group_item_id: {
    storeName: 'budgetGroupItem',
    queryMode: 'local',
    checkField: 'budget_group_item_id',
    valueField: 'budget_group_item_id',
    caption: 'Nhóm mục chi'
  },
  budget_group_item_code: {
    storeName: 'budgetGroupItem',
    queryMode: 'local',
    checkField: 'budget_group_item_code',
    valueField: 'budget_group_item_code',
    caption: 'Nhóm mục chi'
  },
  // Mẫu số hóa đơn
  invoice_form_number_id: {
   // storeName: 'invoiceFormNumber', 
    queryMode: 'local',
    checkField: 'invoice_form_number_id',
    valueField: 'invoice_form_number_id',
    caption: 'Mẫu số HĐ'
  },
  invoice_form_number_code: {
    storeName: 'invoiceFormNumber', 
    queryMode: 'local',
    checkField: 'invoice_form_number_code',
    valueField: 'invoice_form_number_code',
    caption: 'Mẫu số HĐ'
  },
  // Đề tài
  topic_id: {
    storeName: 'topic',
    queryMode: 'local',
    checkField: 'topic_id',
    valueField: 'topic_id',
    caption: 'Đề tài'
  },
  topic_code: {
    storeName: 'topic',
    queryMode: 'local',
    checkField: 'topic_code',
    valueField: 'topic_code',
    caption: 'Đề tài'
  },
  // Kho
  stock_id: {
    storeName: 'stock',
    queryMode: 'local',
    checkField: 'stock_id',
    valueField: 'stock_id',
    caption: 'Kho'
  },
  stock_code: {
    storeName: 'stock',
    queryMode: 'local',
    checkField: 'stock_code',
    valueField: 'stock_code',
    caption: 'Kho'
  },
  // phòng ban
  department_id: {
    storeName: 'department',
    queryMode: 'local',
    checkField: 'department_id',
    valueField: 'department_id',
    caption: 'Phòng ban'
  },
  department_code: {
    storeName: 'department',
    queryMode: 'local',
    checkField: 'department_code',
    valueField: 'department_code',
    caption: 'Phòng ban'
  },
  // CTMT dự án
  project_id: {
    //storeName: 'project', 
    queryMode: 'remote',
    checkField: 'project_id',
    valueField: 'project_id',
    caption: 'CTMT, dự án'
  },
  project_code: {
    //storeName: 'project', 
    queryMode: 'remote',
    checkField: 'project_code',
    valueField: 'project_code',
    caption: 'CTMT, dự án'
  },
  // Khách hàng, nhà cung cấp, cán bộ
  accounting_object_id: {
    queryMode: 'remote',
    checkField: 'accounting_object_id',
    valueField: 'accounting_object_id',
    caption: 'Khách hàng, nhà cung cấp'
  },
  accounting_object_code: {
    queryMode: 'remote',
    checkField: 'accounting_object_code',
    valueField: 'accounting_object_code',
    caption: 'Khách hàng, nhà cung cấp'
  },
  debit_accounting_object_code: {
    queryMode: 'remote',
    checkField: 'accounting_object_code',
    valueField: 'debit_accounting_object_code',
    caption: 'Khách hàng, nhà cung cấp'
  },
  credit_accounting_object_code: {
    queryMode: 'remote',
    checkField: 'accounting_object_code',
    valueField: 'credit_accounting_object_code',
    caption: 'Khách hàng, nhà cung cấp'
  },
  ACCOUNTINGOBJECTCODE: {
    queryMode: 'remote',
    checkField: 'accounting_object_code',
    valueField: 'ACCOUNTINGOBJECTCODE',
    caption: 'Cán bộ'
  },
  // Tài khoản NH, KB
  bank_info_id: {
    queryMode: 'remote',
    checkField: 'bank_info_id',
    valueField: 'bank_info_id',
    caption: 'Tài khoản NH, KB'
  },
  bank_account: {
    queryMode: 'remote',
    checkField: 'bank_account',
    valueField: 'bank_account',
    caption: 'Tài khoản NH, KB'
  },
  // Vật tư hàng hóa
  inventory_item_id: {
    queryMode: 'remote',
    checkField: 'inventory_item_id',
    valueField: 'inventory_item_id',
    caption: 'Vật tư hàng hóa'
  },
  inventory_item_code: {
    queryMode: 'remote',
    checkField: 'inventory_item_code',
    valueField: 'inventory_item_code',
    caption: 'Vật tư hàng hóa'
  },
  // Tài sản cố định
  fixed_asset_id: {
    queryMode: 'remote',
    checkField: 'fixed_asset_id',
    valueField: 'fixed_asset_id',
    caption: 'Tài sản cố định'
  },
  fixed_asset_code:  {
    queryMode: 'remote',
    checkField: 'fixed_asset_code',
    valueField: 'fixed_asset_code',
    caption: 'Tài sản cố định'
  }
};
